import { render, staticRenderFns } from "./FormList.vue?vue&type=template&id=514909ad&scoped=true&"
import script from "./FormList.vue?vue&type=script&lang=js&"
export * from "./FormList.vue?vue&type=script&lang=js&"
import style0 from "./FormList.vue?vue&type=style&index=0&id=514909ad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514909ad",
  null
  
)

export default component.exports